// Import the appropriate config based on the environment
import { CONFIG as PROD_CONFIG } from '../config/config';
import { CONFIG as LOCAL_CONFIG } from '../config/config.local';

// Determine if we're running locally
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Use the appropriate config
const CONFIG = isLocalhost ? LOCAL_CONFIG : PROD_CONFIG;

export const APP = {
    baseurl: CONFIG.baseurl,
    cidaas: CONFIG.cidaas,
    cidaas_revoke: CONFIG.cidaas_revoke
}
